export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/LP_04-16f64c2d22eea102e3de0de65c94e8db.jpg";